export enum EnrolledPermissions {
  AllJuniors = 'all-juniors',
  TodoJuniors = 'todo-juniors',
  ImportJuniors = 'import-juniors',
  AddJunior = 'add-junior',
}